import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Jumbotron, Row, Col, Alert } from 'react-bootstrap';
import Answer from '../answer';
import './style.scss';

const Question = ({ id, description, className, answers, handleAnswer }) => {
  const [active, setActive] = useState(false);
  const [answered, setAnswered] = useState([]);
  const handleSelectAnswer = value => {
    const answeredIndex = answered.findIndex(item => item === value);
    if (answeredIndex >= 0) {
      setAnswered(currentAnswered => currentAnswered.filter(item => item !== value));
    } else {
      setAnswered(currentAnswered => [...currentAnswered, value]);
    }
  };

  useEffect(() => {
    if (answered.length) {
      setActive(true);
    } else {
      setActive(false);
    }
    handleAnswer(id, answered);
  }, [answered]);
  return (
    <Jumbotron className={`jb ${className}`}>
      <Alert variant={active ? 'success' : 'dark'} className="question">
        <h4 dangerouslySetInnerHTML={{ __html: description }} />
      </Alert>
      <Row className="answer-list">
        {(answers || []).map(answer => (
          <Col md={6} key={answer.id}>
            <Answer
              type="MULTIPLE"
              id={answer.id}
              value={answer.question}
              handleChange={handleSelectAnswer}
              checked={answered.includes(answer.id)}
            />
          </Col>
        ))}
      </Row>
    </Jumbotron>
  );
};

Question.propTypes = {
  id: PropTypes.number.isRequired,
  description: PropTypes.string.isRequired,
  className: PropTypes.string,
  answers: PropTypes.arrayOf(Answer).isRequired,
  handleAnswer: PropTypes.func.isRequired
};

Question.defaultProps = {
  className: ''
};

export default Question;
